var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{attrs:{"color":"primary","title":"CONNECT YOUR WALLET"},on:{"click":_vm.onConnect}})}
var staticRenderFns = []

export { render, staticRenderFns }